export default __webpack_public_path__ + "static/media/banner.afd4ddc8.jpg";